import Mock from 'mockjs'

const List = []
const count = 100

const baseContent = '<p>I am testing data, I am testing data.</p><p><img src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>'
const image_uri = 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3'

for (let i = 0; i < count; i++) {
  List.push(Mock.mock({
    id: '@increment(1)', // id
    savetm: +Mock.Random.date('T'), // 入库时间

    'TEMPNAME|1': ['河道(日报)', '水情(日报)', '雨量(日报)', '水文(日报)', '水库(日报)'], //
    'TYPE|1': ['河道', '水情', '雨量', '水文', '水库'], //
    'ENABLEDSTA|1': ['启用', '停用'], // 管理单位
    LASTTM: +Mock.Random.date('T'), //
    REMARK: '@first', //

    lastuser: '@first', // 上传人
    reviewer: '@first',
    // locality: '@integer(2000, 2020)年',//管理单位
    username: '@first', // 用户姓名
    pwd: '123456',
    gropname: '@first', // 分组名
    'locality|1': ['水利部', '长江委水位'], // 管理单位
    'instcd|1': ['0', '1'], // /管理单位
    memo: '@integer(2000, 2020)年', // 备注
    content_short: 'mock data',
    content: baseContent,
    forecast: '@float(0, 100, 2, 2)',
    importance: '@integer(1, 3)',
    'type|1': ['CN', 'US', 'JP', 'EU'],
    'usertype|1': ['0', '1'], // 文件状态
    display_time: '@datetime',
    comment_disabled: true,
    pageviews: '@integer(300, 5000)',
    image_uri,
    platforms: ['a-platform']
  }))
}

export default [
  {
    url: '/vue-element-admin/Flood/GetUserList',
    type: 'get',
    response: config => {
      const { instcd, usertype, username, page = 1, limit = 20, sort } = config.query

      const mockList = List.filter(item => {
        if (instcd && item.instcd !== instcd) return false
        if (usertype && item.usertype !== usertype) return false
        if (username && item.username.indexOf(username) < 0) return false
        return true
      })

      // if (sort === '-id') {
      //   mockList = mockList.reverse()
      // }

      const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

      return {
        code: 20000,
        // data: {
        //   total: mockList.length,
        //   items: pageList
        // }
        data: pageList,
        total: mockList.length
      }
    }
  },
  {
    url: '/vue-element-admin/Flood/AddUser',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },

  {
    url: '/vue-element-admin/Flood/UpdateUser',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },
  {
    url: '/vue-element-admin/Flood/DeleteUserList',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  }
]

